export const enTranslations = {
  agentGrm: {
    ADD_DETAILS: "Add Details",
    CATEGORY: "Category",
    COMMON_SUB_CATEGORY: "Sub-Category",
    COMMON_SUB_SUB_CATEGORY: "Sub-Sub-Category",
    GRIEVANCE_SUBJECT: "Sub-Sub-Category",
    grmApplication: "GRM Application",
    grmApplicationSubText:
      "Choose the Category under which your complaint falls",
    selectCategoryType: "Select Category Type",
    selectSubCategoryType: "Select Sub-Category, Sub-Sub-Category Type",
    categoryType: "Categoy Type",
    governmentSchemesRelated: "Government Schemes Related Services",
    privateSchemeRelated: "Private Schemes Related Services",
    governmentSR: "Government Services related",
    privateSR: "Private Sector Services related",
    SELECT_SUB_CATEGORY: "Select Sub-Category",
    SELECT_SUB_SUB_CATEGORY: "Select Sub-Sub-Category",
    SELECTED_FILES: "Uploaded Files",
    SUB_CATEGORY: "Sub-Category",
    WRITE_COMMENTS: "Write your comments",
    UPLOAD_FILES: "Upload Files",
    GRM_CREATE_SUCCESS_MSG: "Grievance has been Raised Successfully",
    GRM_TICKET_NUMBER: "Ticket Number",
    COMMON_RESEND_ANOTHER_OTP: "Didn't Recieve?? Resend in",
    COMMON_RESEND_ANOTHER_OTP_TAIL: "secs",
    GRM: "GRM",
    GRM_APPLICATION: "GRM-Application",
    CATEGORY_SELECTION_ERROR: "Please select Category",
    SUB_CATEGORY_SELECTION_ERROR: "Please select Sub-Category",
    SUB_SUB_CATEGORY_SELECTION_ERROR: "Please Select Sub-Sub-Category",
    SUBMIT: "Submit",
  },
  agentTrack: {
    GRM_TICKET_NUMBER: "Ticket Number",
    SCHEME_TICKET_NUMBER: "Application Number",
    TRACK_SERVICE: "Track Service",
    TRACK_SERVICE_SUBTEXT: "Choose the service under which your want to track",
    GRM_TICKET_NUMBER_ENTER: "Please enter ticket number you want to track",
    SCHEME_TICKET_NUMBER_ENTER:
      "Please enter application number you want to track",
    SELECT_TRACK_OPTION: "Please select the option you want to track",
    TRACK: "Track",
    TRACK_GRM: "GRM",
    TRACK_SCHEME: "Scheme",
    TICKET_VALIDATION_ERROR: "Please Enter Valid Ticket Number",
    SERVICE_VALIDATION_ERROR: "Please Select Service",
  },
  schemeTrack: {
    SCHEMES_TRACK: "Scheme Application Details",
  },
  appBar: {
    home: "Home",
    aboutUs: "About Us",
    schemes: "Programme and Scheme",
    majorCrops: "Major Crops",
    logout: "Log out",
    welcome: "Welcome!",
  },
  home: {
    Dashboard: "Dashboard",
    Schemes: "Schemes",
    homePageCards: {
      newFarmers: "New Farmers Registered",
      applications: "Applications Submitted for Schemes",
    },
    Advisory: "Advisory",
    Marketplace: "Marketplace",
    Grievance: "Grievance",
    Insurance: "Insurance",
    Credit: "Credit",
    ENTER_OTP: "Enter OTP",
  },
  schemes: {
    // Figma 639-63835 / 91-28466 — same key names as
    // rp-revamp-scheme-3547-handoff (kept identical ahead of this branch's
    // eventual rebase, BLOCKERS.md B13/PLAN.md).
    cantRememberDbtId: "Can't remember your DBT ID?",
    recover: "Recover",
    dontHaveDbtId: "Don't have a DBT ID?",
    registerNow: "Register Now",
    allschemes: "Schemes",
    myschemes: "My Schemes",
    searchSchemes: "Search Schemes",
    showingResultsPage: "Showing up to {{results}} results per page",
    more: "More",
    apply: "Apply",
    save: "Save & Next",
    back: "Back",
    close: "Close",
    applyEligibilityFallbackMessage:
      "Your previously submitted application is under process. Please wait for updates.",
    registrationForm: "REGISTRATION FORM",
    agricultureSchemes: "Agriculture Schemes",
    fisheriesSchemes: "Fisheries Schemes",
    horticultureSchemes: "Horticulture Schemes",
    small: "Small",
    medium: "Medium",
    large: "Large",
    "<2acres": "<2 Acres",
    "2-5acres": "2-5 Acres",
    ">5acres": ">5 Acres",
    schemeTypes: "Scheme Types",
    farmerTypes: "Farmer Types",
    landSize: "Land Size",
    appliedBeeScreenError:
      "Only one of the components can be used in honey extraction system and food grade container. Please select yes for one",
    schemesForFarmers: "Schemes for Farmers",
    schemeDetails: "Scheme Details",
    schemeKnowMore: "Know More",
    filterBy: "Filter By",
    sortBy: "Sort By",
    stateScheme: "State Schemes",
    centralSponsored: "Central Sponsored",
    centralScheme: "Central Schemes",
    centralCredit: "Credit-Linked Schemes",
    governmentSchemes: "Government Schemes",
    recommendedSchemes: "Recommended Schemes",
    categoryFilter: "Categories",
    allCategories: "All Categories",
    searchPlaceholder: "Search schemes",
    filtersAria: "Scheme filters",
    directorateAria: "Filter by directorate",
    searchGroupHeading: "Schemes",
    searchResultsAria: "Scheme search results",
    searchNoResults: "No results found.",
    appliedSchemes: "Applied Schemes",
    appliedSchemesCountNote: "({{count}} schemes has been applied)",
    recommendedEmpty: "No eligible schemes found for you right now.",
    recommendedAgentPending:
      "Recommended schemes for this farmer aren't available in assisted mode yet.",
    // Shared "no results" panel (Figma 639-51479) — SchemesEmptyState.
    goToSchemesPage: "Go to Schemes page",
    allSchemesEmptyTitle: "No schemes found",
    allSchemesEmptySubtitle: "No schemes match your selected filters right now.",
    recommendedEmptyTitle: "No recommended schemes",
    applied: {
      // Status pill label, keyed on the raw application.status value (closed set).
      status: {
        SUBMITTED_SUCCESSFULLY: "Pending",
        PENDING: "Pending",
        REQUEST_IN_PROCESS: "In Process",
        APPROVED: "Approved",
        REJECTED: "Rejected",
        INVALID_APPLICATION: "Invalid Application",
        FAILED: "Failed",
        DUPLICATE_APPLICATION: "Duplicate Application",
        default: "Invalid Application",
      },
      appliedOn: "Applied on",
      applicationNumber: "Application number",
      downloadForm: "Download Form",
      downloadError: "File not downloaded",
      sortRecent: "Most recent",
      pageTitle: "Applied Scheme",
      detailsPageTitle: "Applied Scheme Details",
      source: "Source",
      updatedOn: "Updated on",
      statusTimelineTitle: "Status",
      appliedSchemeStep: "Applied Scheme",
      statusReason: "Reason: {{reason}}",
      kisanCallCentre: "Kisan call centre :",
      copyNumber: "Copy number",
      numberCopied: "Number copied",
      emptyTitle: "No scheme Applied",
      emptySubtitle: "No schemes have been applied to this record.",
    },
    sortAll: "All",
    sortNew: "New",
    sortClosingSoon: "About to close",
    showingOfItems: "Showing {{count}} of {{total}} items",
    directorate: {
      all: "All",
      horticulture: "Horticulture",
      agriculture: "Agriculture",
      fisheries: "Fisheries",
      soilConservation: "Soil Conservation",
    },
    applicationWindow: "Application Window",
    schemeAbout: "About this Scheme",
    schemeGuidelines: "Scheme Guidelines",
    guidelines: "Guidelines",
    schemeApplyNow: "Apply",
    schemeVerifyFarmer: "Verify your account",
    schemeVerifyFarmerSubtext:
      "Please verify farmer DBT details before proceeding",
    farmerDBTId: "Enter Farmer's DBT Id",
    farmerMobileNumber: "Enter Farmer’s Mobile Number",
    // Figma 639-62984 — placeholder INSIDE the input box, distinct from the
    // label above it (farmerDBTId/farmerMobileNumber). Was missing entirely.
    farmerDBTIdPlaceholder: "Enter DBT ID",
    farmerMobileNumberPlaceholder: "Enter mobile number",
    verifyUsing: "Verify using",
    verifyByDbtId: "DBT ID",
    verifyByMobile: "Mobile No.",
    editMobileNumber: "Edit mobile number",
    otpSentMessage: "Enter the 6 digit OTP sent to {{mobile}}",
    memberOtpSentMessage:
      "An OTP has been sent to the member's registered mobile number",
    getOTP: "Generate OTP",
    sendingOTP: "Sending OTP...",
    otpVerifieng: "Verifying OTP",
    otpSuccess: "OTP Sent!",
    otpFailed: "OTP Failed!!",
    enterOTP: "Enter OTP",
    verify: "Verify OTP",
    resendOtp: "Resend OTP",
    resendOtpIn: "Didn't Receive? Retry in {{time}}s",
    confirmCancel: "Farmer will be logged out!! Are you Sure??",
    confirmNavigation:
      "If logged in, Farmer will be logged out. Are you Sure??",
    confirmCancelTitle: "Are you sure you want to cancel the scheme application?",
    confirmCancelSubtext: "All the progress will be deleted.",
    confirmCancelYes: "Yes, Cancel",
    confirmCancelNo: "No, Continue",
    confirmCategorySwitchTitle: "Are you sure you want to switch the category?",
    confirmCategorySwitchSubtext:
      "All the details you've entered for this application will be cleared.",
    confirmCategorySwitchYes: "Yes, Switch",
    applicationSubmittedTitle: "{{schemeName}} Application Submitted Successfully!",
    applicationSubmittedSubtitle:
      "Your scheme application has been submitted. Our team will review it and get back to you shortly.",
    applicationIdLabel: "ID: {{id}}",
    copyApplicationId: "Copy application ID",
    applicationIdCopied: "Application ID copied",
    downloadSchemePdf: "Download Scheme PDF",
    appliedOnLabel: "Applied On : {{date}}",
    viewAppliedScheme: "View Applied Scheme",
    applicationTypeRequired: "Please select applicant type.",
    createSchemeApplication: "Create Scheme Application",
    enterDetailsForFarmerApplication:
      "Enter the following details to create farmer application.",
    applicationForm: "Select Applicant Type",
    selectCategory: "Select Category",
    individualDesc: "Apply as a single farmer for benefits on your own land.",
    groupDesc:
      "Apply as a group of farmers (FPO/SHG/Cooperative) to receive benefits collectively.",
    open: "Open",
    closed: "Closed",
    new: "New",
    alreadyApplied: "Applied",
    viewDetails: "View Details",
    breadcrumbSchemeDetails: "Scheme Details",
    breadcrumbApplyScheme: "Apply Scheme",
    breadcrumbPreview: "Details Preview",
    endsOn: "Ends on {{date}}",
    period: "Period: {{range}}",
    closesToday: "Closes today",
    closesInDay: "Closing in 1 day",
    closesInDays: "Closing in {{count}} days",
    default: "Default",
    gramUnit: "Gram",
    kilogramUnit: "Kilo Gram",
    latest: "Latest",
    sortAlphAsc: "A -> Z",
    sortAlphDesc: "Z -> A",
    noSchemes: "No Schemes Available",
    fetchingLocationData: "Fetching location data...",
    locationDataLoaded: "Location data loaded successfully",
    addRecord: "Add Record",
    removeRecord: "Remove record",
    submit: "Submit",
    confirmLandDetails: "{{component}} values will be cleared. Are you sure??",
    farmerConsent:
      "I hereby declare that I am filling this application on behalf of the farmer, and all the details shared above are correct. If any of the above information is found to be untrue, I shall be responsible for the rejection of this application, and the subsidy amount can be recovered from the farmer, making me liable for penal proceedings.",
    preview: "Preview",
    cancel: "Cancel",
    previous: "Previous",
    next: "Next",
    saveContinue: "Save & Continue",
    savePreview: "Save & Preview",
    personalDetails: "Personal Details",
    chooseFilesToUpload: "Choose Files to Upload",
    autoFilledFromDbt: "Auto-filled from DBT",
    stepAriaLabel: "Step {{n}} of {{total}}: {{label}}",
    scrollStepsLeft: "Scroll steps left",
    scrollStepsRight: "Scroll steps right",
    yes: "Yes",
    no: "No",
    totalArea: "Total Area",
    totalAppliedArea: "Total Applied Area",
    totalAreaAcre: "Total Area - {{area}} acre",
    totalAppliedAreaAcre: "Total Applied Area - {{area}} acre",
    seedQuantity: "Seed Quantity - {{quantity}} {{unit}}",
    remove: "Remove",
    submitApplication: "Submit Application",
    documentPreview: "Uploaded files",
    editForm: "Edit Form",
    addressDetailsPreview: "Address details",
    homePage: "Home Page",
    SCHEME_CREATE_MESSAGE: "Application has been successfully submitted",
    schemeCreated: "Applied Date : {{date}}",
    schemeNumber: "Appl. No.: {{number}}",
    applicationStatus: "Status: {{status}}",
    fileSizeInfo: "Max file size: 2MB",
    alreadyAppliedSeed: "Farmer has already applied.",
    documentContentEmpty:
      "There is currently no content available for this section. You may check back later for updates.",
    selectSeasonSeed: "Select Season",
    seedTable: {
      code: "Code",
      scheme: "Scheme",
      schemeComponent: "Scheme Component",
      crop: "Crop",
      cropVariety: "Crop Variety",
      seedType: "Seed Type",
      rate: "Rates",
      grantPercent: "Grant ( % )",
      grantPerKg: "Grant/kg",
      maxLimit: "Maximum limit",
      apply: "Apply",
    },
    unableToFetchSubSchemes: "Unable to fetch the sub schemes for this scheme. Please try again later",
    paginationTitle: "Showing upto {{count}} results per page",
    type: "Type",
    name: "Name",
    individualBorvelWork: "Borewell work",
    schemeSubName: "Scheme Name",
    cropCode: "Scheme Code",
    bananaCols: {
      S_No: "S. No.",
      strain: "Strain",
      appliedAreaFor: "Applied Area for (in acres)*",
    },
    NOFORM:
      "Application form not available at the moment. Please try again later.",
    applyEligibilityClosed:
      "This scheme is no longer accepting applications.",
    INVALIDURL: "Unable to open the application page. Please try again later.",
    trackingNumber: "Tracking Ticket No.",
    // Non-DBT-linked citizen dialog (Figma 639-27088) — replaces the old
    // requiredRegistrationGRM toast.
    dbtRequiredTitle: "To avail the benefits sync your DBT ID.",
    dbtRequiredCta: "Input DBT ID",
  },

  schemeErrors: {
    fieldIsRequired: "Please enter value",
    invalidEmail: "Invalid email address",
    invalidIntegerFormat: "Invalid Integer Number Format",
    invalidDecimalFormat: "Invalid Decimal Number Format",
    minLengthError: "Min Required length is {{length}}",
    maxLengthError: "Max {length} characters allowed",
    minValueError: "Total Value should not be less than {{min}}",
    maxValueError: "Total Value should not exceed {{max}}",
    totalAreaExceedsMax: "Total area should not exceed {{max}} acres",
    appliedAreaExceedsTotal: "Applied area must be less than the total area",
    totalAreaError: "Total Area should not exceed {{max}}",
    totalAreaMinError: "Total Area should not be less than {{min}}",
    totalAppliedAreaError: "Total Applied Area should not exceed {{max}}",
    totalAreaShuskError:
      "Application cannot be submitted if the area applied for is more than the area in description of land",
    radioRequired: "Select one",
    checkboxRequired: "Please select checkbox",
    fileRequired: "No File Selected",
    appliedAcreageError:
      "Applied Acerage ({{floatVal}}) cannot exceed the total area ({{totalArea}}).",
    districtNotEligible: "Farmer district is not eligible for the scheme",
    pmksyError:
      "The PMKSY scheme isn't available for groups in assisted mode. Please choose 'Individual' to continue.",
    addNewRowError: "Please fill/submit the current entry.",
    addNewRowPreviewError: "Please submit the entry.",
    pleaseEnterValueMin: "Please enter at least {{min}} value(s)",
    duplicateReturnPolicy: "Please select diffrent value",
    litchiOnlyRaiyat: "Only raiyat farmer can apply for litchi component",
  },
  GRM_RESOLVED: "Resolved",
  COMMON_EDIT: "Edit",
  COMMON_BACK: "Back",
  COMMON_RESEND_OTP: "Didn't Receive? Resend OTP",
  SESSION_EXPIRE_ERROR: "Your session has expired. Please log in to continue.",
  SCHEME_BENEFITS: "Scheme Benefits",
  SCHEME_HAS_ERRORS:
    "Please complete the required fields before previewing the scheme. Ensure all fields are filled in correctly.",
  SCHEME_APPLICATION_CREATE_ERROR:
    "This application cannot be submitted at this time. Please check back later.",
  SCHEME_APPLICATION_NOT_FOUND: "Scheme Application not found",
  REQUEST_IN_PROCESS: "Request in Progress",
  SUBMITTED_SUCCESSFULLY: "Submitted successfully",
  FAILED: "Failed",
  REJECTED_TRACK: "Rejected",
  SCHEME_DOWNLOAD_RECIEPT: "View and Download Receipt",
  AllContacts: "All Contacts",
  Login: "Login",
  CantLogin: "Forgot Password?",
  AGENT_FARMER_REGISTRATIONS: "Farmer Registrations",
  AGENT_GRM_REQUESTS: "GRM Requests Raised",
  AGENT_SCHEMES_APPLIED: "Schemes Applied",
  BENIFICIARY_ID: "Beneficiary ID",
  BENIFICIARY_NAME: "Beneficiary Name",
  COMMON_CLOSE: "Close",
  COMMON_DONE: "Done",
  COMMON_HISTORY: "History",
  COMMON_NO_FILE_SELECTED: "No File Selected",
  COMMON_NEXT: "Next",
  COMMON_SCROLL_LEFT: "Scroll left",
  COMMON_SCROLL_RIGHT: "Scroll right",
  COMMON_PREVIOUS: "Previous",
  COMMON_PROCEED_WITH_OTP: "Proceed with OTP",
  COMMON_DOWNLOAD_RECIEPT: "View and Download Receipt",
  COMMON_CONGRATS: "Congratulations !",
  COMMON_LOADING: "Loading, please wait...",
  COMMON_VIEW_ALL: "View All",
  copyright: "Copyright",
  DATE_TIME: "Date & Time",
  DFSWEB_AGENT: "Agent",
  DFSWEB_ASSETS: "Assets",
  Policy: "Policy",
  AccessibilityStatement: "Accessibility Statement",
  DFSWEB_LOGIN_PAGE: "Login",
  DFSWEB_ASSETS_details: "Assets Details",
  ASSETS_CATEGORY_NOT_FOUND: "No assets found for this category",
  DFSWEB_CAROUSEL: "Carousel",
  DFSWEB_DFS_REGISTRATION: "Registration",
  DFSWEB_GRM: "GRM",
  DFSWEB_HELP: "Help",
  Help: "Help",
  "Help-details": "Help details",
  DFSWEB_HOME: "Home",
  DFSWEB_HISTORY: "History",
  DFSWEB_DASHBOARD: "Dashboard",
  Privacy_policy: "Privacy policy",
  Accessibility_statement: "Accessibility Statement",
  DFSWEB_MANDIPRICE: "Mandi Price",
  DFSWEB_SCHEMES: "Schemes",
  DFSWEB_FAQs: "FAQs",
  DFSWEB_About: "About Us",
  DFSWEB_About_Bihar: "About Us",
  DFSWEB_Latest_Updates: "Latest Updates",
  DFSWEB_Success_Volumes: "Success Volumes",
  // ── Rewamp appbar (DFS-3360) ──────────────────────────────────────────────
  REWAMP_NAV_ADVISORIES: "Advisory",
  REWAMP_NAV_KNOWLEDGE: "Knowledge",
  REWAMP_NAV_TRACK_STATUS: "Track Status",
  REWAMP_NAV_FARMER_REGISTRATION: "Farmer Registration",
  REWAMP_NAV_LOGIN_REGISTER: "Login/Register",
  REWAMP_COMING_SOON: "Coming Soon",
  REWAMP_COMING_SOON_BADGE: "Coming Soon",
  REWAMP_COMING_SOON_TITLE: "Coming Soon",
  REWAMP_COMING_SOON_MESSAGE: "This feature is currently being built and will be available soon. We will notify you once it is live.",
  REWAMP_COMING_SOON_OKAY: "Okay",
  REWAMP_COMING_SOON_KNOWLEDGE_TITLE: "Knowledge is under Development",
  REWAMP_NEWS_NO_UPDATES_TITLE: "No recent updates",
  REWAMP_NEWS_EMPTY_DESC: "Stay tuned for updates from the Department of Agriculture.",
  REWAMP_NEWS_NEWS_DESC: "News will appear here once published. Stay tuned for updates from the Department of Agriculture.",
  REWAMP_NEWS_STAY_TUNED_DESC: "Stay tuned for updates from the\nDepartment of Agriculture.",
  REWAMP_NEWS_ARCHIVED_TITLE: "No archived",
  "Load more": "Load more",
  REWAMP_FAQ_NO_UPDATES_TITLE: "No FAQs yet",
  REWAMP_FAQ_EMPTY_DESC: "FAQs for this category will be added soon.",
  REWAMP_FAQ_PREPARING_DESC: "Our team is preparing answers to the most common questions. They'll be published here shortly.",
  REWAMP_KISAAN_HELPLINE: "Kisaan Helpline",
  DFSWEB_SERVICEPROVIDER: "Service Provider",
  "Edit-profile": "Edit-Profile",
  ENTER_VALUE: "Enter Value",
  SELECT_VALUE: "Select Value",
  FETCH_PGR_ERROR: "Grievance Details not found, Please try again",
  FILE_UPLOADING: "Uploading",
  FILE_UPLOAD_FAILED: "Failed",
  FILE_UPLOADED: "Uploaded",
  Grm: "GRM",
  HISTORY_TICKET_NUMBER: "Application/Ticket Number",
  INVALID_TICKET_ID: "Grievance Details not found, Please try again",
  DFSWEB_TRACK: "Track",
  PERSONAL_DETAILS: "Personal Details",
  Location_DETAILS: "Location Details",
  "Personal information": "Personal Details",
  "Personal Information": "Personal Details",
  "Location information": "Location Details",
  "Location Information": "Location Details",
  Bank_DETAILS: "Bank Details",
  PROFILE_CREATE: "Non-DBT Registration",
  PROFILE_UPDATE: "DBT Profile Sync",
  DBT_PROFILE_CREATE: "DBT Registration",
  SCHEME_APPLY: "Apply Scheme",
  KnowMore: "Know More",
  GRM_APPLY: "Grievance Creation",
  OTP_VALIDATION_FAILED: "Incorrect OTP",
  TECH_COMMON_SUBMIT: "Submit",
  DFSWEB_GRM9: "Report and Track Issue",
  dialogContent:
    "You are being redirected to an external website. Please note that Bihar Krishi Website cannot be held responsible for external websites content & privacy policies.",
  Frequently_Asked_Questions: "Frequently Asked Questions",
  govtOfBihar: "Government of Bihar",
  lastUpdate: "Last Updated",
  BiharKrishiSupport: "Bihar Krishi Support",
  KisanCallCentre: "Kisan Call Centre(Toll free)",
  DBTPortal: "DBT Portal",
  BiharSeedCertificationAgency: "Bihar State Seed and Organic Certification Agency (BSSOCA)",
  BWDS: "Bihar Watershed Development Society(BWDS)",
  DEPARTMENT_REVENUE_LAND_REFORM: "Department of Revenue and Land Reforms",
  BAVAS: "Bihar Agricultural Produce Value Addition System (BAVAS)",
  PM_KISHAN: "PM Kisan",
  BRBN: "Bihar Rajya Beej Nigam (BRBN)",
  BAMETI: "Bihar Agriculture Management & Extension Training Institute",
  DirectorateofHorticulture: "Directorate of Horticulture",
  KisanCallCentrePortal: "Kisan Call Centre Portal",
  header: "ContactInformation",
  ContactInformation: "Contact Information",
  OtherImportantLinks: "Other Important Links",
  ImportantLinks: "Important Links",
  FOLLOW_US: "Follow Us",
  krishiAppPlay: "To avail Government schemes, Download the Bihar Krishi app",
  schemeBanner: "View all active state and central-sponsored schemes.",
  Click: "Click",
  imp_updates: "Important Updates",
  DepartofAgri: "Department of Agriculture",
  Cancel: "Cancel",
  OK: "OK",
  EMPTY_DBT_ID: "Please enter the DBT ID and then proceed.",
  INVALID_DBT_ID:
    "The entered DBT ID is invalid. Please check your input and try again.",
  EMPTY_MOBILE_NUMBER: "Please enter the mobile number and then proceed.",
  INVALID_MOBILE_NUMBER:
    "The entered mobile number is invalid. Please enter a valid 10-digit number and try again.",
  FARMER_DOES_NOT_EXIST:
    "Your mobile number is not registered on Bihar Krishi. Please register to avail benefits and services.",
  NON_DBT_USER: "To avail the benefits kindly register with DBT",
  INVALID_OTP: "Incorrect OTP",
  INCORRECT_OTP: "Incorrect OTP",
  IP_ADDRESS_ERROR: "Getting your IP address, please wait...",
  KeyContacts: "Key Contacts",
  LatestNews: "Latest News",
  LearnMore: "Learn More",
  LogInToAccount: "Log in to your Account",
  NumberAboutOurSuccess:
    'Numbers that speak volumes about our <span style="color: {{color}}; font-size: {{fontSize}}">Success!</span>',
  Success: "Success!",
  Skip_to_main_content: "Skip to Content",
  "Switch to English": "Switch to English",
  "Switch to Hindi": "Switch to Hindi",
  "Open Accessibility Options": "Open Accessibility Options",
  Screenreaderaccess: "Screen Reader Access",
  ScreenReader: "Screen Reader",
  Website: "Website",
  FreeCommercial: "Free / Commercial",
  OurOfferings: "Our Offerings",
  Photos: "Photos",
  QuickAction: "Quick Actions",
  ReadMore: "Read More",
  ReadLess: "Read Less",
  REPORT_A_ISSUE: "Report an Issue",
  scan_to_download: "Scan this to download Bihar Krishi Mobile App",
  Social: "Social Media",
  TICKET_NUMBER: "Ticket No.",
  TRACK_ISSUE_STATUS: "Track Issue Status",
  TYPE_OF_REQUEST: "Type of Request",
  Videos: "Videos",
  View_all_daq: "View All FAQs",
  View: "View",
  ViewAllOfferings: "View All Offerings",
  ViewAllSchemes: "View All Schemes",
  GotoRegistration: "Go to Registration",
  CreateTicket: "Create Ticket",
  ViewDetails: "View Details",
  FILE_TYPE_ERROR: "File Type Not Supported",
  FILE_UPLOAD_FAILED_ERROR: "Failed to upload. Please try again!",
  UPLOAD_FILES: "Upload Files",
  REJECTED: "REJECTED",
  SCHEME_APPLICATION_GET_ERROR: "Scheme Application Not Found",
  Mandi: "Mandi Price",
  "Price-details": "Price Details",
  COMMODITY_PRICE_HEADER: "Price",
  MANDI_COMMODITY_PRICE_TREND: "Price Trend",
  MANDI_PAST_PRICES_LABEL: "Past Prices",
  PRICE_QUINTOL: "qt",
  MANDI_PRICE_HEADER: "Mandi Price",
  MANDI_MARKET_PRICE: "Market Price",
  COMMON_APPLY: "Apply",
  COMMON_DISTRICT: "District",
  COMMON_BLOCK: "Block",
  COMMON_VILLAGE_PANCHAYAT: "Village Panchayat",
  MANDI_MARKET: "Market",
  MANDI_COMMODITY_CROP: "Crop/Commodity",
  COMMON_ID: "Id",
  COMMON_NAME: "Name",
  Manager: "Manager",
  COMMON_DELETE: "Delete",
  COMMON_DELETE_WARNING: "Are you sure you want to delete this item?",
  COMMON_DELETE_SELECTED_ITEMS_WARNING:
    "Are you sure you want to delete the selected item(s)?",
  COMMON_YES_DELETE: "Yes, Delete",
  // Were missing (FarmerSelfRegistration.js already referenced these keys
  // without a translation existing — added while wiring
  // RewampNonDbtRegistrationForm's Jeevika Yes/No radio).
  COMMON_YES: "Yes",
  COMMON_NO: "No",
  // Was missing — ActionConfirmationDialog's Cancel button (logout/delete/
  // leave-registration confirms) referenced this key without a translation.
  COMMON_CANCEL: "Cancel",
  COMMON_YES_CONTINUE: "Yes, Continue",
  COMMON_CONTINUE: "Continue",
  DELETE_SUCCESSFUL: "Record deleted successfully",
  DELETE_MULTI_SUCCESSFUL: "Record(s) deleted successfully",
  "Data-cleanup": "Data Review",
  DELETE_FAILED: "Failed to delete record(s), please try again",
  DFSWEB_DATA_REVIEW: "Data Review",
  DFSWEB_DATA_REVIEW_DESC: "Manage data from here",
  MANDI_FROM_DATE: "From Date",
  MANDI_TO_DATE: "To Date",
  COMMON_DATE: "Date",
  MANDI_COMMODITY: "Commodity",
  MANDI_VARIETY: "Variety",
  MANDI_PRICE: "Price",
  MANDI_MIN_PRICE: "Min Price",
  MANDI_MAX_PRICE: "Max Price",
  MANDI_ERROR_LOADING_MARKET_DATA: "Error Loading Data",
  MANDI_NO_MARKET_DATA: "No Data Available",
  NoRecordFound: "No suggestions found",
  MANDI_DATE_FILTER_ERROR: "Please Select",
  SELECT_Date: "Select Date",
  VERIFY_FARMER: "Verify Farmer Details",
  APPLICATION_FORM: "Application Form",
  PREVIEW_SUBMIT: "Preview & Submit",
  Categories: "Categories",
  QuickFilters: "Quick Filters",
  Filters: "Filters",
  Privacypolicy: "Privacy Policy/Terms of Use Page.",
  SearchAssets: "Search assets",
  Search: "Search",
  SearchContact: "Search Contacts",
  contactPerson: "Contact Person",
  activities: "Business Areas",
  cropName: "Crop Name: ",
  CROP_NAME: "Crop Name",
  Type: "Type",
  Name: "Name",
  CapacityDetails: "Capacity Details",
  EstYear: "Est. Year",
  MobileNo: "Mobile No.",
  Established: "Established",
  Address: "Address",
  ASSET_BANK_NAME: "Bank Name",
  ASSET_BRANCH_NAME: "Branch Name",
  ASSET_BRANCH_ADDRESS: "Branch Address",
  ASSET_IFSC_CODE: "IFSC Code",
  ASSET_BANK_CODE: "Bank Code",
  ASSET_BRANCH_CODE: "Branch Code",
  ASSET_BRANCH_STATUS: "Status",
  ASSET_ALL: "All",
  ASSET_SELECT_DISTRICT: "Select District",
  ASSET_SELECT_BLOCK: "Select Block",
  ASSET_SELECT_BANK: "Select Bank",
  ASSET_SELECT_BRANCH: "Select Branch",
  ASSET_PICK_BLOCK_PROMPT: "Select a district and block to view Jaivik FPOs",
  ASSET_PICK_DISTRICT_INDUSTRY_PROMPT: "Select a district to view units",
  ASSET_JAIVIK_FPO_NAME: "FPO Name",
  ASSET_MAJOR_CROPS: "Major Crops",
  ASSET_INDUSTRY_UNIT_NAME: "Unit Name",
  ASSET_INDUSTRY_STATUS: "Status",
  ASSET_INDUSTRY_CAPACITY: "Capacity",
  ASSET_INDUSTRY_CONTACT: "Contact No.",
  ASSET_INDUSTRY_PRODUCT: "Product",
  ASSET_INDUSTRY_PROJECT_COST: "Project Cost",
  ASSET_INDUSTRY_ESTABLISH_YEAR: "Establish Year",
  licenseNo: "License No.",
  currentBalance: "Current Balance",
  sourceText: "Source: ",
  sourceWeather: "Bihar Mausam Sewa Kendra",
  Assets_home_text:
    "Welcome to the Agri Resource section, where you can easily view categorized information on various agricultural institutions and resources available across all districts of Bihar. Here, you can access details and contact information for agricultural resources available throughout the state. Additionally, using the in-app call feature, you can directly call any contact number provided in this section to get in touch with the relevant person instantly.",
  farmerRegistration: {
    PERSONAL_DETAILS: "PERSONAL DETAILS",
    DBT_ID: "DBT ID",
    FARMER_NAME: "Farmer's name",
    "FATHER/MOTHER/HUSBAND_NAME": "Father/Mother/Husband Name",
    DATE_OF_BIRTH: "Date of Birth",
    AGE: "Age",
    GENDER: "Gender",
    MOBILE_NUMBER: "Mobile Number",
    FARMER_TYPE: "Farmer's type",
    CASTE_CATEGORY: "Caste category",
    FARMER_CATEGORY: "Farmer's category",
    DISTRICT: "District",
    BLOCK: "Block",
    VILLAGE_PANCHAYAT: "Village Panchayat",
    VILLAGE: "Village",
    PINCODE: "Pincode",
    RESEND_OTP: "Resend OTP",
    PLEASE_VERIFY: "Please Verify",
    // SENT_OTP_TO_MOBILE_NO:
    //   "We have sent you an OTP to your registered mobile number {number}.",
    OTP_SENT_TO_MOBILE_NO_1:
      "An OTP has been sent to the farmer's registered mobile number ending in",
    OTP_SENT_TO_MOBILE_NO_2: "",
    VERIFY: "Verify",
    DBT_SYNC: "DBT Sync",
    RETRY1: "Retry in",
    RETRY2: "",
    SUBMIT: "Submit",
    CHANGE_PHOTO: "Change Photo",
    DIDNOT_RECIEVE: "Didn't Recieve?",
    FARMER_ALREADY_EXIST: "Farmer already exist in Bihar Krishi",
    BANK_NAME: "Bank Name ",
    ACCOUNT_NUMBER: "Bank Account Number",
    IFSC_CODE: "IFSC Code",
    BANK_BRANCH_ADDRESS: "Bank Branch Address",
    CONGRATULATIONS: "Congratulations!",
    REGISTRATION_UPDATE_SUCCESSFUL:
      "Your Bihar Krishi registration has been successfully updated",
    REGISTRATION_CREATE_SUCCESSFUL:
      "Your Bihar Krishi registration has been successfully created",
    OWN: "Own",
    RENTED: "Rented",
    MIXED: "Own Land + Rented Land",
    SMALL: "Small Farmer (1-2 hectares)",
    MEDIUM: "Marginal Farmer (Less than 1 hectare)",
    LARGE: "Large Farmer (more than 2 hectares)",
    MALE: "Male",
    FEMALE: "Female",
    OTHER: "Other",
    MINORITY: "Minority",
    SC: "Scheduled Castes",
    ST: "Scheduled Tribes",
    OBC: "Other Backward Classes",
    BACKWARD: "Backward Classes",
    GENERAL: "General",
    REQUIRED_FARMER_NAME: "Please write name of farmer",
    REQUIRED_RELATIVE_NAME: "Please write name of farmer's relative",
    REQUIRED_DOB: "Please write DOB",
    REQUIRED_AGE: "Please write age of farmer",
    REQUIRED_GENDER: "Please select gender of farmer",
    REQUIRED_MOBILE_NUMBER: "Please write the mobile no.",
    MAXLENGTH_MOBILE_NUMBER: "Mobile number must not exceed 10 characters",
    MINLENGTH_MOBILE_NUMBER: "Mobile number must be at least 10 characters",
    REQUIRED_FARMER_TYPE: "Please select type of farmer",
    REQUIRED_CASTE_CATEGORY: "Please select caste category of farmer",
    REQUIRED_FARMER_CATEGORY: "Please select category of farmer",
    REQUIRED_DISTRICT: "Please select district",
    REQUIRED_BLOCK: "Please select block",
    REQUIRED_PANCHAYAT: "Please select panchayat",
    REQUIRED_VILLAGE: "Please select village",
    PINCODE_PATTERN: "Enter a valid pincode of 6 digits",
    PINCODE_REQUIRED: "Please enter the pincode",
    NOT_AVAILABLE: "Not Available",
    MOBILE_MAXLENGTH: "Mobile number must not exceed 10 characters",
    FARMER_NAME_MINLENGTH: "Farmer name should be at least 2 characters",
    FARMER_RELATIVE_NAME_MAXLENGTH:
      "Farmer relative name should not be more then 100 characters",
    MOBILE_MINLENGTH: "Mobile number must be at least 10 characters",
    UNEXPECTED_ERROR: "An unexpected error occurred.",
    UPDATE_NOT_SUPPORTED:
      "Sync failed: Mobile number has changed. Please contact support.",
    PHOTO_UPLOAD_SUCCESS: "Photo Uploaded Successfully",
    EG_FILESTORE_INVALID_INPUT:
      "Invalid file type. Please upload: [JPG, JPEG, PNG].",
    OTP_SEND_FAILED: "Failed to send OTP. Please try again.",
    OTP_RESEND_FAILED: "Failed to resend OTP. Please try again.",
    INVALID_DBT_ID:
      "The entered DBT ID is invalid. Please check your input and try again.",
    RE_LOGIN: "Re-Login",
    RE_LOGIN_MESSAGE:
      "Your mobile number has been updated with the number in your DBT account, kindly logout",
    RE_LOGIN_HEADER: "We're sorry, DBT ID & Mobile number don't match",
  },
  Humidity: "Humidity",
  WindDirection: "Wind Direction",
  WindSpeed: "Wind Speed",
  Rain: "Rain",
  Max_MinTemp: "Max/Min Temp.",
  Max_MinTemperature: "Max / Min Temperature",
  Date: "Date",
  day_forcast: "3 Days Forecast",
  TodayWeather: "Today's weather",
  weather: {
    Sun: "Sun",
    Mon: "Mon",
    Tue: "Tue",
    Wed: "Wed",
    Thu: "Thu",
    Thur: "Thu",
    Fri: "Fri",
    Sat: "Sat",
  },
  N: "N",
  E: "E",
  S: "S",
  W: "W",
  NE: "NE",
  SE: "SE",
  SW: "SW",
  NW: "NW",
  North: "North",
  East: "East",
  South: "South",
  West: "West",
  "North East": "North East",
  "South East": "South East",
  "South West": "South West",
  "North West": "North West",
  mm: "mm",
  "km/h": "km/h",
  // Weather category tags (backend categoryCode → label; condition fallbacks).
  "Mostly Sunny": "Mostly Sunny",
  Sunny: "Sunny",
  Clear: "Clear",
  "Partly Cloudy": "Partly Cloudy",
  "Mostly Cloudy": "Mostly Cloudy",
  Cloudy: "Cloudy",
  Overcast: "Overcast",
  Rainy: "Rainy",
  Showers: "Showers",
  Thunderstorm: "Thunderstorm",
  Storm: "Storm",
  Windy: "Windy",
  Fog: "Fog",
  Drought: "Drought",
  Winter: "Winter",
  Night: "Night",
  Weatherdata: "Weather",
  Sun: "Sunday",
  Mon: "Monday",
  Tue: "Tuesday",
  Wed: "Wednesday",
  Thur: "Thursday",
  Fri: "Friday",
  Sat: "Saturday",
  get_direction: "Get Directions",
  directions: "Directions",
  Bihar: "Bihar",
  Q: "Q",
  A: "A",
  Acc: "A",
  COMMON_USERNAME: "Username",
  COMMON_PASSWORD: "Password",
  COMMON_ENTER_PASSWORD: "",
  notEligible:
    "Sorry, this location isn't available. Please choose a different one.",
  notAvaliable:
    "Sorry! Location details doesn't match. Please contact support.",
  Complaintdetails: "Grievance Details",
  Sitemap: "Site Map",
  landingPage: "Landing Page",
  Footer: "Footer",
  Storage: "Storage",
  Office: "Agri Offices",
  Education: "Agri Institutes",
  Bazaar: "Bazaar",
  Market: "Bazaar",
  Indutries: "Industries",
  OtherAssets: "Other Assets",
  Cold_Storage: "Cold Storage",
  Agri_Godowns: "Agri Godowns",
  Panchayat_Office: "Panchayat Office",
  "e-Kisan_Bhavan": "e-KISAN Bhawan",
  DAO_Office: "DAO Office",
  KVK: "KVK",
  Agriculture_College: "Agriculture College",
  Pashu_Bazaar: "Pashu Bazaar",
  Market_Nodes: "Market Nodes",
  Agri_Input_Shops: "Agri-Input Shops",
  Agriculture_Farms: "Agriculture Farms",
  Rice_Mill: "Rice Mill",
  Custom_Hiring_Center: "Custom Hiring Centre",
  "Fpo-Farmers_Producers_Services": "Farmers Producers Organisation",
  Commodity_Price: "Commodity Price",
  Contact_US: "Contact Us",
  TrackScheme: "Scheme Track",
  FARMER_PASSBOOK: "Farmer Passbook",
  "Farmer-passbook": "Farmer Passbook",
  "Agent-access": "Verification",
  PROCESSING_PASSBOOK_INFO:
    "Fetching your passbook. This may take a moment, please check back later.",
  NO_PASSBOOK_RECORDS: "No passbook records found.",
  Choose_Year: "Choose Year",
  SL_NO: "Sl.No",
  Sub_Scheme_Name: "Sub Scheme Name",
  Application_Date: "Application Date",
  Subsidy_Type: "Subsidy Type",
  Settlement_Date: "Settlement Date",
  Benefit_Allocation: "Benefit Allocation",
  Download_PDF: "Download PDF",
  PDF: "PDF",

  help: {
    SpeaktoDOAOfficials: "Speak to DOA Officials/Call us",
    CallCenters: "Call Centres",
    DBTIDRelatedServices: "DBT ID Related Services",
    OtherRelevantServices: "Other Relevant Services",
    MandiAnalysts: "Mandi Analysts",
    CertificationInspectors: "Certification Inspectors(Seed/Organic)",
    SAO: "SAO",
    AgricultureCoordinator: "Agriculture coordinator",
    KisanSalahkar: "Kisan Salahkar",
    NominatedACforMarketNodes: "Nominated AC for Market Nodes",
    AssistantDirectorofPlantProtection:
      "Assistant Director of Plant Protection",
    EthanolIndustries: "Ethanol Industries",
    JaivikFPOs: "Jaivik FPOs",
    ReportTechnicalissue: "Report Technical issue",
    Foodprocessing: "Food processing ",
    bac: "BAC",
    availableTimings: "Available Timings",
    availableDays: "Available Days",
    Capacity: "Capacity",
    Status: "Status",
    status: "Status",
    address: "Address",
    capacity: "Capacity",
    establishYear: "Establish Year",
    productName: "Product Name",
    majorCrops: "Major Crops",
    commoditiesTraded: "Commodities Traded",
    oci: "Organic Certification Inspector",
    si: "Seed Certification Inspector",
    si1: "Seed Certification Inspector- 1",
    si2: "Seed Certification Inspector- 2",
    si3: "Seed Certification Inspector- 3",
    dao: "DAO",
    dho: "DHO",
    ade: "ADE",
    adc: "ADC",
    noDataFound: "No data found. Please check back later or refine your search",
  },
  //soil health
  Soil_health: "Soil Health",
  soil_health_Detail: "Soil Health Details",
  "Soil-health-details": "Soil Health Details",
  soil_health_labs: "Soil Testing Labs",
  soil_health_card: "Soil Health Card",
  agriAdvisory: "Agri Advisory",
  filterByDistrict: "Filter by District",
  Distance: "Distance",
  approx: "Approx.",
  KM: "KM",
  Email: "Email",
  phoneNumberCopied: "Phone number copied",
  bankDetailsCopied: "Bank details copied",
  WhatsApp: "WhatsApp",
  copyBankDetails: "Copy",
  sortBy: "Sort By",
  sortNearest: "Nearest",
  sortNameAsc: "Name (A-Z)",
  Download: "Download",
  FinancialYears: "Financial Years",
  TestGrid: "Test Grid",
  KhataKasara: "Khata/Khasara",
  selectAtLeast1NPK:
    " Please select at least one of Nitrogen, Phosphate, or Potash.",
  selectAtLeast1Crop:
    "Please select at least one crop and its corresponding yield.",
  GenerateReport: "Generate Report",
  Potash: "Potash",
  Phosphate: "Phosphate",
  Nitrogen: "Nitrogen",
  Yield: "Yield",
  Crop: "Crop",
  selectCrop: " Please select Crops and Target Yields",
  LandSize: "Land Size",
  Check_more_crop: "Check more Crop",
  selectNPK: " Please select fertilizer, you wish to use",
  NPKGroup: "N.P.K Group",
  name: "Name",
  SoilHealthId: "Soil Health Card id:",
  Validity: "Validity:",
  DataAnalysis: "Data Analysis",
  Resource: "Resource",
  testDate: "Test Date:",
  BasedInput: "Data Analysis: Data shown based on Inputs:",
  Share: "Share",
  whereShare: "Please select where you want to share the soil details",
  "Farmer-details": "Verify Farmer Details",
  selectAnotherYear:
    "Please select another financial year to view the records.",
  SessionTimeout: "Farmer session has expired.",
  selectArea: "Please select Area and Unit",
  whatsAppSuccess:
    "WhatsApp message sent successfully. Please check after 2-3 minutes",
  whatsAppFailure:
    "There was an issue with sending the WhatsApp message. Please try again later.",
  farmersDashboard: "Farmers Registrations",
  schemesApplications: "Scheme Applications",
  grmDashboard: "GRM",
  COMMON_AMOUNT: "Amount",
  Radio: "Radio",
  Bihar_Krishi_Radio: "Tune in to Bihar Krishi Radio",
  Now_playing_Radio: "Now Playing Bihar Krishi Radio",
  Play: "Play",
  Pause: "Pause",
  Stop: "Stop",
  Mute: "Mute",
  Unmute: "Unmute",
  Volume: "Volume",
  Reviews: "Reviews",
  Percentage: "Percentage",
  Star: "Star",
  Stars: "Stars",
  selectAValue: "Please select a value",
  Farmer: "Farmer",
  Others: "Others",
  COMMON_MOBILE: "Enter Mobile Number",
  // Figma 91-27308 — farmer login mobile step
  FARMER_LOGIN_MOBILE_LABEL: "Mobile No",
  FARMER_LOGIN_MOBILE_PLACEHOLDER: "Enter mobile no.",
  GENERATE_OTP: "Generate OTP",
  // Figma 521-6842 — other (employee) login step
  OTHER_LOGIN_USERNAME_PLACEHOLDER: "Enter Username",
  OTHER_LOGIN_PASSWORD_PLACEHOLDER: "Enter Password",
  COMMON_USERNAME_REQUIRED: "Please enter username",
  COMMON_PASSWORD_REQUIRED: "Please enter password",
  OTHER_LOGIN_INVALID_CREDENTIALS: "Incorrect username or password",
  COMMON_SERVER_ERROR: "Something went wrong. Please try again.",
  COMMON_LOGIN_TYPE: "Login Type",
  dbt_dfs_registered_phone: "DBT or DFS -registered mobile number",
  additional_information: "Additional Information",
  are_you_physically_disabled: "Are you physically disabled?",
  // Placeholder pending BLOCKERS.md B6 (legal/product consent copy) — see
  // notes/rewamp/onboarding/BLOCKERS.md.
  FARMER_LOGIN_CONSENT:
    "I consent to Bihar Krishi using my personal information for government schemes, advisories, policies, insurance and related services. My data will be kept secure in accordance with statutory laws.",
  // Figma 91-29540/91-29711 — exact copy, shared by both onboarding branches.
  ONBOARDING_ACCOUNT_CREATED_TITLE: "Welcome to Bihar Krishi!",
  ONBOARDING_ACCOUNT_CREATED_SUBTITLE:
    "Your registration has been completed successfully. We are delighted to have you as a part of the Bihar Krishi Community.",
  ONBOARDING_ACCOUNT_CREATED_CTA: "Continue",
  ONBOARDING_CREATING_PROFILE_TITLE: "Creating your profile",
  ONBOARDING_CREATING_PROFILE_SUBTITLE:
    "This may take a few moments. Please wait while we set things up for you.",
  ONBOARDING_CREATING_PROFILE_FAILED_TITLE: "Unable to create your profile",
  ONBOARDING_CREATING_PROFILE_FAILED_SUBTITLE:
    "We couldn't set up your farmer profile from DBT records. Please retry or cancel to return to sign in.",
  COMMON_RETRY: "Retry",
  // Figma 91-28466/91-28693 — non-DBT registration form.
  ONBOARDING_NON_DBT_BANNER:
    "Not registered under DBT?  You can still onboard by filling in the details below.",
  ONBOARDING_NAME_PLACEHOLDER: "Enter your Name",
  ONBOARDING_DISTRICT_PLACEHOLDER: "Select District",
  ONBOARDING_BLOCK_PLACEHOLDER: "Select Block",
  ONBOARDING_PANCHAYAT_PLACEHOLDER: "Select Panchayat",
  ONBOARDING_JEEVIKA_MEMBER: "Are you a JEEViKA Member?",
  ONBOARDING_JEEVIKA_ID: "JEEViKA ID",
  ONBOARDING_JEEVIKA_ID_PLACEHOLDER: "Enter JEEViKA ID",
  ONBOARDING_SHG_NAME: "Name of the SHG",
  ONBOARDING_SHG_PLACEHOLDER: "Enter name of the SHG",
  ONBOARDING_VO_NAME: "Name of the VO",
  ONBOARDING_VO_PLACEHOLDER: "Enter name of the VO",
  ONBOARDING_CLF_NAME: "Name of the CLF",
  ONBOARDING_CLF_PLACEHOLDER: "Enter name of the CLF",
  // Figma 520-4764 / 520-4894 — OTP verification chrome + inline feedback.
  ONBOARDING_OTP_VERIFICATION_TITLE: "OTP Verification",
  ONBOARDING_ACCOUNT_VERIFICATION_TITLE: "Verify Your Account",
  ONBOARDING_ACCOUNT_VERIFICATION_BREADCRUMB: "Account Verification",
  ONBOARDING_OTP_SENT_PREFIX: "Enter the 6 digit OTP sent to ",
  ONBOARDING_OTP_ENTER_LABEL: "Enter OTP",
  ONBOARDING_OTP_EXPIRED: "OTP has expired. Please request a new one.",
  ONBOARDING_OTP_INCORRECT: "Incorrect OTP",
  ONBOARDING_OTP_RETRY_IN: "Didn't Receive? Retry in {{time}}s",
  COMMON_OTP_REQUIRED: "Please enter the OTP.",
  COMMON_FIELD_REQUIRED: "Please fill in this field",
  ONBOARDING_SIGNIN_DBT: "DBT",
  ONBOARDING_SIGNIN_NON_DBT: "Non-DBT",
  ONBOARDING_FIELD_NAME_REQUIRED: "Please enter your name",
  ONBOARDING_FIELD_DISTRICT_REQUIRED: "Please select a district",
  ONBOARDING_FIELD_BLOCK_REQUIRED: "Please select a block",
  ONBOARDING_FIELD_PANCHAYAT_REQUIRED: "Please select a panchayat",
  ONBOARDING_FIELD_GENDER_REQUIRED: "Please select gender",
  ONBOARDING_FIELD_JEEVIKA_REQUIRED: "Please select JEEViKA membership",
  ONBOARDING_FIELD_SHG_REQUIRED: "Please enter SHG name",
  ONBOARDING_FIELD_VO_REQUIRED: "Please enter VO name",
  ONBOARDING_FIELD_CLF_REQUIRED: "Please enter CLF name",
  ONBOARDING_LEAVE_REGISTRATION_WARNING:
    "Please complete your registration to access this feature.",
  // Recover DBT ID — Figma 91-32001…32601 (mobile string parity).
  ONBOARDING_RECOVER_TITLE: "Recover your DBT ID",
  ONBOARDING_RECOVER_SEND_OTP: "Send OTP",
  ONBOARDING_RECOVER_METHOD_LABEL: "Select Recovery Method",
  ONBOARDING_RECOVER_METHOD_MOBILE: "Contact Number",
  ONBOARDING_RECOVER_METHOD_EMAIL: "Email ID",
  ONBOARDING_RECOVER_EMAIL_LABEL: "Email ID",
  ONBOARDING_RECOVER_EMAIL_HINT: "Enter your Email ID",
  ONBOARDING_RECOVER_MOBILE_LABEL: "Mobile Number",
  ONBOARDING_RECOVER_MOBILE_HINT: "Enter Mobile Number",
  ONBOARDING_RECOVER_MOBILE_NOT_REGISTERED: "This mobile number is not registered with DBT.",
  ONBOARDING_RECOVER_NOTE:
    "A 6-digit OTP will be sent to this number if it is registered with your DBT ID.",
  ONBOARDING_RECOVER_CONTINUE: "Continue",
  ONBOARDING_RECOVER_CAPTCHA_LOADING: "Loading verification...",
  ONBOARDING_RECOVER_CAPTCHA_LOAD_FAILED: "Unable to load verification. Please retry.",
  ONBOARDING_RECOVER_CAPTCHA_TITLE: "Security verification",
  ONBOARDING_RECOVER_CAPTCHA_SUBTITLE:
    "Confirm you are not a bot before we send the OTP to your mobile number.",
  ONBOARDING_RECOVER_CAPTCHA_VERIFY_CTA: "Verify & continue",
  ONBOARDING_RECOVER_CAPTCHA_VERIFYING: "Verifying…",
  ONBOARDING_RECOVER_CAPTCHA_VERIFYING_HINT: "This usually takes a few seconds. Please wait.",
  ONBOARDING_RECOVER_CAPTCHA_VERIFIED: "Verification complete",
  ONBOARDING_RECOVER_CAPTCHA_VERIFIED_HINT:
    "You can now send the OTP to your registered mobile number.",
  ONBOARDING_RECOVER_CAPTCHA_VERIFY_FAILED: "Verification failed. Please try again.",
  ONBOARDING_RECOVER_CAPTCHA_EXPIRED: "Verify that you are not a robot",
  ONBOARDING_RECOVER_OTP_TITLE: "Mobile Number Verification for DBT Id",
  ONBOARDING_DBT_ID_OTP_TITLE: "Verify Your DBT ID Using the OTP",
  ONBOARDING_RECOVER_OTP_SUBTITLE: "Enter the 6 digit OTP sent to your Mobile Number",
  ONBOARDING_RECOVER_RESULT_TITLE: "Application of Recover DBT ID",
  ONBOARDING_RECOVER_RESULT_ALERT:
    "Dear {{name}}, your Farmer Registration Number (DBT) has been recovered successfully. Your registration number is {{dbtId}}. Please keep it safe, as it is required to receive subsidy benefits.",
  ONBOARDING_RECOVER_CONTINUE_LOGIN: "Continue",
  ONBOARDING_RECOVER_DETAIL_DBT_ID: "DBT Id",
  ONBOARDING_RECOVER_DETAIL_NAME: "Name",
  ONBOARDING_RECOVER_DETAIL_MOBILE: "Mobile Number",
  ONBOARDING_RECOVER_DETAIL_DOB: "Date of birth",
  ONBOARDING_RECOVER_DETAIL_DISTRICT: "District",
  ONBOARDING_RECOVER_DETAIL_PANCHAYAT: "Panchayat",
  ONBOARDING_RECOVER_DETAIL_FATHER_OR_HUSBAND: "Father or Husband Name",
  ONBOARDING_RECOVER_DETAIL_GENDER: "Gender",
  ONBOARDING_RECOVER_DETAIL_FARMER_TYPE: "Farmer Type",
  ONBOARDING_RECOVER_DETAIL_BLOCK: "Block",
  ONBOARDING_RECOVER_DETAIL_VILLAGE: "Village",
  ONBOARDING_RECOVER_COPY_LABEL: "Copy DBT Id",
  ONBOARDING_RECOVER_COPIED: "Copied to clipboard",
  ONBOARDING_RECOVER_DOWNLOAD: "Download",
  otp_sent_message_1:
    "We have sent you an OTP to your registered mobile number {{maskedMobile}}.",
  otp_sent_message_2: "",
  COMMON_MOBILE_INVALID: "This number is not registered",
  COMMON_MOBILE_RATE_LIMIT: "Rate limit exceeded, please try again after sometime",
  All_Schemes: "All Schemes",
  Applied_Schemes: "Applied Schemes",
  Recommended_Schemes: "Recommended Schemes",
  Group_description: "Group Description",
  "Acreage_(in_Acres)": "Acreage (in Acres)",
  "Applied_acreage_(in_acres)": "Applied acreage (in acres)",
  "Applied_Unit_(125_Sq.m._Per_Unit)": "Applied Unit (125 Sq.m. Per Unit)",
  remarks: "Remarks",
  Refresh: "Refresh",
  Close: "Close",
  requiredRegistrationGRM:
    "DBT registration is mandatory for applying to schemes of Agriculture department. Please register on DBT portal before applying",
  nonDbtNoticeGrievance:
    "Raising a grievance with the Agriculture department requires a DBT-linked profile. Please update your profile with your DBT ID to continue.",
  nonDbtNoticeScheme:
    "Applying for Agriculture department schemes requires a DBT-linked profile. Please update your profile with your DBT ID to continue.",
  nonDbtNoticeCta: "Update profile",
  soilNoTargetsNotice:
    "Your block does not have targets for the current session year, Thank you.",
  Date_of_Application: "Date of Application",
  APPLICATION_STATUS: "Application Status",
  Applied: "Applied",
  address: "Address",
  COMMON_MOBILE_REQUIRED: "Please enter mobile number",
  COMMON_MOBILE_INVALID_LENGTH: "Mobile number should be of 10 digits",
  MOBILE_NUM_CHANGE_1:
    "Kindly note, The DBT ID entered by you is linked with another mobile no {{maskedMobileNumber}}. If this is your mobile number then kindly enter the complete mobile number to proceed. Please note that profile details associated with this mobile number will be mapped to this profile.",
  MOBILE_NUM_CHANGE_2:
    "If you are sure, then Please click on continue button or click on cancel button to go back",
  FETCHED_DATA: "Data Fetched Successfully",
  MOBILE_MISMATCH: "Mobile numbers do not match",
  WEATHER: "Weather",
  cropSelect: "Select Crop",
  yieldSelect: "Select Yield",
  AADHAAR_NAME: "Name as on Aadhaar",
  MOBILE_ALREADY_REGISTERED:
    "Mobile number is already registered. Please login with this Mobile number.",
  selfRegistration: {
    haveDBT: "Do you have DBT ID?",
    registerDBT: "Do you want to register with D.B.T.?",
    dbtLinkHelper:
      "Click on the link given below to register in the D.B.T. portal",
    dbtDetails: "DBT Details",
    fetchData: "Fetch DBT Data",
    fetchPermission: "Would you like to get details from D.B.T. portal?",
    dbtInputLabel: "Farmer D.B.T. Registration number (13 digit)",
    continue: "Continue",
    mobileInputLabel: "Mobile Number",
    mobileInputHelper:
      "Use the DBT registered mobile number {{maskedMobile}} for signup",
    back: "Back",
    notEligible:
      "Sorry! Location details doesn't match. Please contact support.",
    DBT_ERROR:
      "Error fetching dbt details from the server, please try again after sometime",
  },
  Farmer_Registration: "Farmer-Registration",
  Recover_DBT_ID: "Recover DBT ID",
  kg: "kg",
  BACK_TO_LOGIN: "Back to Login",
  OTHER_LOGIN: "Other Log In",
  FARMER_LOGIN: "Farmer Log In",
  DOWNLOAD_APP: "Download App",
  HORTI_MODULE_TITLE: "Horticulture",
  HORTI_ENQUIRY_HISTORY: "Enquiry History",
  GOOGLE_PLAY: "Google Play",
  BANNER_DBT_ID_LABEL: "DBT ID Registration — secure, hassle-free. Apply today.",
  BANNER_BIGHAAT_LABEL: "BigHaat — Buy all agricultural products online.",
  BANNER_APP_DOWNLOAD_LABEL: "Download the Bihar Krishi app from Google Play.",
  GA4_AVERAGE_SESSION_DURATION: "Average Session Duration",
  GA4_DAILY_ACTIVE_USERS: "Daily Active Users",
  COMMON_NO_DATA: "No data",
  SOMETHING_WENT_WRONG: "Something went wrong. Please try again.",
  MIDH_DUPLICATE_CROP_EXCEPTION: "Farmer already has an application in process for this crop.",
  // Real backend code (SCHEME003.drl) — unprefixed, distinct string from the
  // constant above. Same copy so the generic t(code)-with-fallback toast
  // picks it up with no special-casing, whichever spelling the backend sends.
  DUPLICATE_CROP_EXCEPTION: "Farmer already has an application in process for this crop.",
  MAX_FILES_INFO: "Maximum number of files uploaded",
  FOLDER_UPLOAD_NOT_SUPPORTED: "Folders cannot be uploaded. Please choose a file.",
  DOWNLOAD_DOCUMENT: "Download Document",
  PhotoDoc: "Photo Document",
  GroupDoc: "Group Document",
  LandDoc: "Land Document",
  NO_DATA_FOUND: "No results found",
  COMMON_SEARCH: "Search",
  REWAMP_GLOBAL_SEARCH: "Search",
  REWAMP_ERROR_BOUNDARY_TITLE: "Something went wrong",
  REWAMP_ERROR_BOUNDARY_BODY:
    "This page could not be displayed. You can try again, or go back to the home page.",
  REWAMP_ERROR_BOUNDARY_RETRY: "Try again",
  COMMON_RESET: "Reset",
  COMMON_CLEAR: "Clear",
  ClearAll: "Clear All",
  REWAMP_RECENT_SEARCHES: "Recent Searches",
  REWAMP_SEARCH_LINK_UNAVAILABLE: "Sorry, this result isn't available right now.",
  REWAMP_SEARCH_VIDEO_DIALOG:
    "This video opens on YouTube, an external website. Please note that the Bihar Krishi Website cannot be held responsible for external websites' content & privacy policies.",
  REWAMP_RECENT_SEARCH_REMOVE: "Remove recent search",
  FARMER_AGE_DISTRIBUTION: "Farmer Age Distribution",
  FARMER_GENDER_DISTRIBUTION: "Farmer Gender Distribution",
  FARMER_TYPE_DISTRIBUTION: "Farmer Type Distribution",
  GA4_FARMER_CATEGORY: "Farmer Category Distribution",
  GA4_DAILY_USER_RETENTION: "Daily User Retention",
  CUMULATIVE_ACTIVE_USERS: "Cumulative Active Users",
  DSS_NOTIFICATION_READ_RATE: "Notification Read Rate",
  DSS_CALL_CENTER: "Call Center",
  DSS_SCHEME_AWARENESS: "Scheme Awareness",
  DSS_ADVISORY_READ_RATE: "Advisory Read Rate",
  ANDROID_VERSION: "Operating System Version Distribution",
  FARMER_CATEGORY_DISTRIBUTION: "Farmer Category Distribution",
  SCHEME_APPLICATION_GENDER: "Gender Distribution for Scheme Applications",
  DSS_SCHEME_ENROLLMENT_BIFURCATION: "Scheme Enrollment Breakdown",
  DSS_SCHEME_FARMERS_CATEGORY_WISE_DISTRIBUTION: "Scheme Farmers Category-wise Distribution",
  DSS_FARMERS_REGISTERED_BY_GENDER: "Farmer Registration by Gender",
  DSS_SESSION_FREQUENCY_DISTRIBUTION: "User Session Frequency",

  // summary kpi
  DSS_FARMERS_REGISTERED_SUMMARY: "Registrations",
  GA4_SCHEME_REGISTRATIONS: "Schemes",
  DSS_GRIEVANCE_COUNT_SUMMARY: "GRM",
  ACTIVE_USERS: "Active Users",
  AVERAGE_SESSION_DURATION: "Average Session Duration (HH:MM:SS)",

  MALE: "Male",
  FEMALE: "Female",
  OTHER: "Other",

  AGE: "Age",
  GENDER: "Gender",
  FARMER_TYPE: "Farmer's type",
  CASTE_CATEGORY: "Caste category",
  FARMER_CATEGORY: "Farmer's category",
  DISTRICT: "District",
  BLOCK: "Block",
  PANCHAYAT: "Panchayat",
  VILLAGE: "Village",

  // DSS Filters - Geographic
  DSS_DISTRICTS: "Districts",
  DSS_BLOCKS: "Blocks",
  DSS_PANCHAYATS: "Panchayats",
  DSS_VILLAGES: "Villages",
  DSS_SELECT_GEOGRAPHICAL: "Select Geographical",
  DSS_SELECT_DEMOGRAPHICAL: "Select Demographical",
  DSS_GEOGRAPHICS: "Geographics",
  DSS_DEMOGRAPHICS: "Demographics",
  DSS_FILTERS: "Filters",

  // DSS Filters - JEEVIKA (CLF → VO → SHG)
  DSS_FILTER_JEEVIKA: "JEEViKA",
  DSS_JEEVIKA_SELECT: "Select JEEViKA",
  DSS_JEEVIKA_CLF: "Cluster Level Federation (CLF)",
  DSS_JEEVIKA_VO: "Village Organization (VO)",
  DSS_JEEVIKA_SHG: "Self Help Group (SHG)",
  DSS_JEEVIKA_GROUPS_DISTRIBUTION: "JEEViKA Groups Distributions",
  DSS_IS_JEEVIKA_MEMBER: "JEEViKA Member",

  // DSS Filters - Demographic Options
  DSS_GENDER: "Gender",
  DSS_GENDER_MALE: "Male",
  DSS_GENDER_FEMALE: "Female",
  DSS_GENDER_OTHER: "Other",
  DSS_AGE: "Age",
  DSS_AGE_18_25: "18-25 years",
  DSS_AGE_26_35: "26-35 years",
  DSS_AGE_36_45: "36-45 years",
  DSS_AGE_46_60: "46-60 years",
  DSS_AGE_60_PLUS: "60+ years",
  DSS_FARMER_CATEGORY: "Farmer Category",
  DSS_FARMER_SMALL: "Small Farmer",
  DSS_FARMER_MEDIUM: "Medium Farmer",
  DSS_FARMER_LARGE: "Large Farmer",
  DSS_FARMER_MARGINAL: "Marginal Farmer",
  DSS_SMALL_MARGINAL_FARMER_PENETRATION: "Small-Marginal Farmer Penetration",

  // Device Options
  DSS_DEVICE_MOBILE: "Mobile",
  DSS_DEVICE_TABLET: "Tablet",
  DSS_DEVICE_DESKTOP: "Desktop",


  // DSS Sort
  DSS_SORT_BY: "Sort by",
  DSS_HIGH_TO_LOW: "High to Low",
  DSS_LOW_TO_HIGH: "Low to High",

  // DSS Performers matrix (top / lowest side panels)
  DSS_TOP_PERFORMERS: "Top Performers",
  DSS_LOWEST_PERFORMERS: "Lowest Performers",

  // DSS Pie Chart Display
  DSS_DISPLAY_VALUE: "Display Value",
  DSS_VALUE_AND_PERCENT: "Value & Percentage",
  DSS_PERCENT_ONLY: "Percentage Only",
  DSS_HIDE_SMALL_SLICES: "Hide slices under {{cutoff}}%",
  DSS_LEGEND_PREV_PAGE: "Previous legend page",
  DSS_LEGEND_NEXT_PAGE: "Next legend page",
  DSS_VALUE_ONLY: "Value Only",
  DSS_VALUE_ABSOLUTE: "Absolute",

  // Filter Warning Messages
  DSS_FILTER_WARNING: "Some filters not applicable",
  DSS_FILTERS_NOT_APPLICABLE: "The following filters are not applicable to this chart:",

  // Caste Categories
  DSS_CASTE_GEN: "General",
  DSS_CASTE_OBC: "Other Backward Classes",
  DSS_CASTE_EBC: "Extremely Backward Classes",
  DSS_CASTE_SC: "Scheduled Caste",
  DSS_CASTE_ST: "Scheduled Tribe",
  DSS_CASTE_MINORITY: "Minority",
  DSS_SCHEME_FARMERS_CASTE_WISE_DISTRIBUTION: "Schemes Distribution by Farmer caste",
  DSS_SCHEME_FARMERS_TYPE_WISE_DISTRIBUTION: "Schemes Distribution by Farmer type",

  // DSS Dashboard Categories
  DSS_CATEGORY_USER_STICKINESS: "User Stickiness",
  DSS_CATEGORY_DEMOGRAPHICS: "Demography",
  DSS_CATEGORY_VERSION_DETAILS: "Version Details",
  DSS_CATEGORY_PROFILE: "Profiles",
  DSS_CATEGORY_MARKETING: "Marketing",
  DSS_CATEGORY_COMPARE: "Compare",
  DSS_COMPARE: "Compare",
  DSS_COMPARE_DASHBOARDS: "Dashboards",
  DSS_COMPARE_CHARTS: "Charts",
  DSS_COMPARE_EMPTY_HINT: "Select dashboards and charts from the Compare filter to compare them here.",
  DSS_COMPARE_MODE_NORMAL: "Dashboards",
  DSS_COMPARE_MODE_TEMPORAL: "Temporal",
  DSS_COMPARE_TEMPORAL_EMPTY_HINT: "Add cards in the filter panel to compare a chart across date ranges.",
  DSS_TEMPORAL_RANGES: "Date Ranges",
  DSS_TEMPORAL_ADD_RANGE: "Add range",
  DSS_TEMPORAL_MAX_RANGES: "Up to {{count}} ranges",
  DSS_TEMPORAL_RANGE_NAME: "Range name",
  DSS_TEMPORAL_DELETE_RANGE: "Delete range",
  DSS_TEMPORAL_FILTERS_NOTE: "Filters apply to all ranges; only the date window differs.",
  DSS_TEMPORAL_CARDS: "Cards",
  DSS_TEMPORAL_NO_CHARTS: "Pick charts above to compare them across ranges.",
  DSS_TEMPORAL_NO_CARDS: "No cards yet — add one to compare a chart across a range.",
  DSS_TEMPORAL_ADD_CARD: "Add card",
  DSS_TEMPORAL_MAX_CARDS: "Up to {{count}} cards",
  DSS_TEMPORAL_DELETE_CARD: "Remove card",
  DSS_DASHBOARD_FARMER_REGISTRATION: "Farmer Registrations",
  DSS_DASHBOARD_SCHEME: "Scheme Applications",
  DSS_DASHBOARD_GRM: "Grievances",
  FEATURE_USAGE_DASHBOARD: "Feature Usage",
  DSS_FEATURE_USAGE: "Feature Usage",
  DSS_CLICKS_DASHBOARD: "Clicks",
  DSS_UNIQUE_CLICKS: "Unique Clicks",
  DSS_TOTAL_CLICKS: "Total Clicks",
  GA4_OFFLINE_MODE_USAGE: "Offline Mode Usage",
  APP_VERSION: "App Version",
  LOAD_TIME: "Load Time",

  // Filter Key Translations
  DSS_FILTER_GEOGRAPHY: "Geography",
  DSS_FILTER_GENDER: "Gender",
  DSS_FILTER_AGE: "Age",
  DSS_FILTER_FARMER_CATEGORY: "Farmer Category",
  DSS_FILTER_ANDROID_VERSION: "Android Version",
  DSS_FILTER_DEVICE: "Device",
  DSS_FILTER_SCHEME: "Scheme",
  DSS_FILTER_TIME: "Date",

  // Farmer Types
  DSS_TYPE_SMALL: "Small Farmer (1-2 hectare)",
  DSS_TYPE_MARGINAL: "Marginal Farmer (Less than 1 hectare)",
  DSS_TYPE_LARGE: "Large Farmer (More than 2 hectare)",
  DSS_TYPE_TENANT: "Tenant",
  DSS_TYPE_NON_TENANT: "Non-Tenant",
  DSS_TYPE_NOT_AVAILABLE: "Not Available",

  // Date picker labels (if not already present)
  DSS_SELECT_DATE_RANGE: "Select Date Range",
  DSS_START_DATE: "Start Date",
  DSS_END_DATE: "End Date",
  DSS_TODAY: "Today",
  DSS_YESTERDAY: "Yesterday",
  DSS_THIS_WEEK: "This Week",
  DSS_PREVIOUS_WEEK: "Previous Week",
  DSS_THIS_MONTH: "This Month",
  DSS_PREVIOUS_MONTH: "Previous Month",
  DSS_THIS_YEAR: "This Year",
  DSS_PREVIOUS_YEAR: "Previous Year",
  DSS_CUSTOM: "Custom",

  // Update Frequency Labels
  DSS_FREQUENCY_INSTANTANEOUS: "Instantaneous",
  DSS_FREQUENCY_DAILY: "Daily",
  DSS_FREQUENCY_WEEKLY: "Weekly",
  DSS_FREQUENCY_MONTHLY: "Monthly",
  DSS_FREQUENCY_QUARTERLY: "Quarterly",
  DSS_FREQUENCY_YEARLY: "Yearly",
  DSS_UPDATE_FREQUENCY: "Update Frequency",

  GA4_FARMER_LAND_OWNERSHIP_CATEGORY: "Farmer Land Ownership Category",
  DSS_GEOGRAPHIC_DISTIBUTION: "Geographic Distribution",
  DSS_AVERAGE_APP_STORE_RATING: "Average App Store Rating",
  DSS_SCHEMES_DASHBOARDS: "Schemes",
  FARMER_CASTE_DISTRIBUTION: "Farmer Caste-wise Distribution",
  DSS_SCHEME_ENROLLMENT_DISTIBUTION: "Scheme Enrollments",

  // Interval Options
  DSS_INTERVAL: "Interval",
  DSS_INTERVAL_DAY: "Daily",
  DSS_INTERVAL_WEEK: "Weekly",
  DSS_INTERVAL_MONTH: "Monthly",
  DSS_INTERVAL_QUARTER: "Quarterly",
  DSS_INTERVAL_YEAR: "Yearly",
  DSS_SELECT_INTERVAL: "Select Interval",
  DSS_CHART_FREQUENCY: "Chart Frequency",
  DSS_FREQUENCY_AUTO: "Auto",
  WOMAN_FARMER_ADOPTION_DISTRIBUTION: "Women Farmer Adoption Distribution",
  DSS_CURRENT_LEVEL: "Current Level",
  DSS_STATE: "State",
  DSS_DISTRICT: "District",
  DSS_BLOCK: "Block",
  DSS_PANCHAYAT: "Panchayat",
  DSS_VILLAGE: "Village",
  DSS_VALUE: "Value",
  DSS_OTHER: "Other",
  DSS_NOT_AVAILABLE: "Not Available",
  DSS_FILTERS_APPLIED: "Filters Applied",
  DSS_NO_DATA_FOR_DRILL: "No data for this drill parameter",
  GA4_MONTHLY_ACTIVE_USERS: "Monthly Active Users",
  GA4_MONTHLY_DAU_PER_MAU_DISTRIBUTION: "Monthly DAU/MAU Distribution",

  // Chart Indicators
  DSS_CHARTS: "Charts",
  DSS_DIRECT_VIEW: "Overview",
  DSS_PRESENTATIONAL_VIEW: "Detailed View",

  // Chart type switcher labels
  DSS_CHART_TYPE_DONUT: "Donut",
  DSS_CHART_TYPE_LINE: "Line",
  DSS_CHART_TYPE_HORIZONTAL_BAR: "Horizontal Bar",
  DSS_CHART_TYPE_STACKED_BAR: "Stacked Bar",
  DSS_CHART_TYPE_STACKED_COLUMN: "Stacked Column",


  पुरुष: "Male",
  स्त्री: "Female",
  अन्य: "Other",
  NoOptions: "No options",

  DSS_TOTAL: "Total",
  DSS_DOWNLOAD_EXCEL: "Download Excel",
  DSS_DOWNLOAD_CSV: "Download CSV",
  DSS_DOWNLOAD_PDF: "Download PDF",
  DSS_DOWNLOAD_SVG: "Download SVG",
  DSS_DOWNLOAD_JPEG: "Download JPEG",
  DSS_DOWNLOAD_REPORT: "Download Report",
  DSS_EXPORT_SUBMITTING: "Requesting your report…",
  DSS_EXPORT_PREPARING: "Preparing your report…",
  DSS_EXPORT_DOWNLOADING: "Downloading…",
  DSS_EXPORT_DOWNLOADING_PART: "Downloading part {{current}} of {{total}}…",
  DSS_EXPORT_READY: "Your report is ready — download started.",
  DSS_EXPORT_READY_PARTS: "Your report is ready — {{count}} files.",
  DSS_EXPORT_PARTS_COUNT: "{{count}} files",
  DSS_EXPORT_PART: "Part {{seq}}",
  DSS_EXPORT_DOWNLOAD_ALL: "Download all",
  DSS_EXPORT_FAILED: "Report export failed.",
  DSS_EXPORT_STATUS_REFRESH: "Refresh status",
  DSS_EXPORT_CLOSE: "Close",

  DSS_OWNERSHIP_RAIYAT: "Raiyat",
  DSS_OWNERSHIP_NON_RAIYAT: "Non-Raiyat",
  DSS_OWNERSHIP_RAIYAT_NON_RAIYAT: "Raiyat-Non-Raiyat",

  ComingSoon: "Coming Soon…",

  DSS_FILTER_FEATURE: "Feature",
  DSS_FEATURE_GROUP: "Feature Group",
  DSS_FEATURE_SUB_GROUP: "Feature Sub Group",
  DSS_FEATURE_NAME: "Feature Name",
  // Generic hierarchy levels
  DSS_LEVEL_0: "Level 0",
  DSS_LEVEL_1: "Level 1",
  DSS_LEVEL_2: "Level 2",
  DSS_LEVEL_3: "Level 3",
  DSS_LEVEL_4: "Level 4",
  DSS_LEVEL_5: "Level 5",

  DSS_FEATURE_HOME: "Home",
  DSS_FEATURE_ASSETS: "Assets",
  DSS_FEATURE_ADVISORY: "Advisory",
  DSS_FEATURE_HELP: "Help",
  DSS_FEATURE_OTHERS: "Others",

  DSS_FEATURE_SUB_GROUP_SCREEN: "Screen",
  DSS_FEATURE_SUB_GROUP_CAROUSEL: "Carousel",
  DSS_FEATURE_SUB_GROUP_SCHEMES: "Schemes",
  DSS_FEATURE_SUB_GROUP_SCHEME_DETAILS: "Scheme Details",
  DSS_FEATURE_SUB_GROUP_SCHEME_APPLICATION: "Scheme Application",
  DSS_FEATURE_SUB_GROUP_FARMER_PASSBOOK: "Farmer Passbook",
  DSS_FEATURE_SUB_GROUP_ASSET: "Asset",
  DSS_FEATURE_SUB_GROUP_ASSET_LISTS: "Asset Lists",
  DSS_FEATURE_SUB_GROUP_SPECIALIZED_ASSETS: "Specialized Assets",
  DSS_FEATURE_SUB_GROUP_MANDI_PRICE: "Mandi Price",
  DSS_FEATURE_SUB_GROUP_WEATHER: "Weather",
  DSS_FEATURE_SUB_GROUP_PLANT_PROTECTION: "Plant Protection",
  DSS_FEATURE_SUB_GROUP_SOIL_HEALTH: "Soil Health",
  DSS_FEATURE_SUB_GROUP_KNOWLEDGE_SECTION: "Knowledge Section",
  DSS_FEATURE_SUB_GROUP_HELP_AND_SUPPORT: "Help and Support",
  DSS_FEATURE_SUB_GROUP_GRM: "GRM",
  DSS_FEATURE_SUB_GROUP_TECHNICAL_SUPPORT: "Technical Support",
  DSS_FEATURE_SUB_GROUP_USER_ROLES: "User Roles",
  DSS_FEATURE_SUB_GROUP_REGISTRATION: "Registration",
  DSS_FEATURE_SUB_GROUP_OTHERS: "Others",

  SearchCityOrStation: "Search city or station",
  AirQualityIndex: "Air Quality Index",
  WeatherLocationError: "Weather data unavailable for this location. Showing data for your current region.",
  good: "Good",
  satisfactory: "Satisfactory",
  moderate: "Moderate",
  poor: "Poor",
  verypoor: "Very Poor",
  severe: "Severe",
  unableToDecide: "AQI data is currently unavailable. Please try again later!",
  aqiIndex: "AQI Index",
  healthImpact: "Health Impact",
  monitoringStation: "Monitoring Station",



  // alt-labels
  BIHAR_KRISHI_LOGO: "Bihar Krishi Logo",
  BIHAR_KRISHI_SHAHAYAK_LOGO: "Bihar Krishi Shahayak Logo",
  BIHAR_KRISHI_RADIO_LOGO: "Bihar Krishi Radio Logo",
  GOVT_OF_BIHAR_EMBLEM: "Government of Bihar Emblem",
  SCHEME_LOGO: "Scheme Logo",


  TOGGLE_THEME: "Toggle Theme",
  PLAY_OR_PAUSE: "Play or Pause",
  IMPORTANT_UPDATES: "Important Updates",
  Announcements: "Announcements",
  Slide: "Slide",
  SLIDE: "Slide",
  "— QUICK ACCESS": "— QUICK ACCESS",
  "Popular resources": "Popular Resources",
  "— SUPPORT": "— SUPPORT",
  "Help & Support": "Help & Support",
  "Explore more": "Explore more",
  "Rabi Season Active": "Rabi Season Active",
  REWAMP_SEASON_ZAID: "Zaid",
  REWAMP_SEASON_KHARIF: "Kharif",
  REWAMP_SEASON_RABI: "Rabi",
  CS_SEASON_ACTIVE: "Season Active",
  REWAMP_CROP_SEASON_ACTIVE_LABEL: "{{season}} Season Active",
  "Explore Plant Protection Advisory": "Explore Plant Protection Advisory",
  "Crop Selection": "Crop Selection",
  CATEGORIES_EYEBROW: "— Services",
  CROP_ADVISORY_SUBHEADING:
    "Click on a crop name below to see disease details, recommended practices, prevention methods, and treatment solutions.",
  "Unable to load advisory details. Please try again later.":
    "Unable to load advisory details. Please try again later.",
  "No advisory information available for this crop.":
    "No advisory information available for this crop.",
  BANNER_CAROUSEL_LABEL: "Banner carousel",
  CAROUSEL_CONTROLS: "Carousel controls",
  SLIDE_INDICATORS: "Slide indicators",
  NO_IMAGE: "No image available",
  MAIN_NAVIGATION: "Main navigation",
  OPEN_NAVIGATION: "Open navigation menu",
  CLOSE_NAVIGATION: "Close navigation menu",
  More: "More",
  IMPORTANT_UPDATES_CAROUSEL_MOBILE: "Important updates carousel (mobile)",
  IMPORTANT_UPDATES_CAROUSEL_DESKTOP: "Important updates carousel (desktop)",

  Volume_Level: "Volume Level",

  pending: "pending",
  uploading: "uploading",
  success: "success",
  error: "error",

  toDate: "To Date",
  fromDate: "From Date",

  LOGO: "Logo",
  TWEET_MEDIA: "Tweet Media",

  EXAMPLE_EMAIL: "e.g. mukesh1234@email.com",

  SearchQuestion: "Search Question",

  // DSS Feature Groups
  DSS_FEATURE_NEWS_AND_NOTIFICATIONS: "News and Notifications",
  DSS_FEATURE_KNOWLEDGE: "Knowledge",

  // DSS Feature Sub Groups
  DSS_FEATURE_CAROUSEL: "Carousel",
  DSS_FEATURE_IMPORTANT_LINKS: "Important Links",
  DSS_FEATURE_NOTIFICATIONS: "Notifications",
  DSS_FEATURE_GRM: "GRM",
  DSS_FEATURE_CALL_CENTRE: "Call Centre",
  DSS_FEATURE_TECHNICAL_SUPPORT: "Technical Support",
  DSS_FEATURE_OFFICIALS: "Officials",
  DSS_FEATURE_SCHEMES: "Schemes",
  DSS_FEATURE_SCHEMES_APPLIED: "Applied Schemes",
  DSS_FEATURE_FARMER_PASSBOOK: "Farmer Passbook",
  DSS_FEATURE_ASSETS_STORAGE: "Storage",
  DSS_FEATURE_ASSETS_OFFICES: "Offices",
  DSS_FEATURE_ASSETS_INSTITUTES: "Institutes",
  DSS_FEATURE_ASSETS_BAZAR: "Bazar",
  DSS_FEATURE_ASSETS_INDUSTRIES: "Industries",
  DSS_FEATURE_ASSETS_OTHER: "Other Assets",
  DSS_FEATURE_AGRI_TIPS: "Agri Tips",
  DSS_FEATURE_WEATHER: "Weather",
  DSS_FEATURE_SOIL_HEALTH: "Soil Health",
  DSS_FEATURE_MANDI: "Mandi",
  DSS_FEATURE_REGISTRATION: "Registration",
  DSS_FEATURE_PROFILE: "Profile",

  // DSS Feature Components - News and Notifications / Carousel
  TwitterCard: "Twitter Card",
  AnnouncementCard: "Announcement Card",

  // DSS Feature Components - News and Notifications / Important Links
  ImportantServicesScreen: "Important Services",
  DbtRelatedUsefulLink: "DBT Related Useful Link",

  // DSS Feature Components - News and Notifications / Notifications
  NotificationScreen: "Notification",

  // DSS Feature Components - Help/GRM
  GrievanceTicketCreation: "Grievance Ticket Creation",
  GrievanceScreen: "Grievance",

  // DSS Feature Components - Help/Call Centre
  HelpLine: "Help Line",
  CallCentre: "Call Centre",

  // DSS Feature Components - Help/Technical Support
  TechSupportTicketCreation: "Tech Support Ticket Creation",
  TechnicalSupportScreen: "Technical Support",

  // DSS Feature Components - Help/Officials
  MandiAnalyst: "Mandi Analyst",
  KisanSalahkar: "Kisan Salahkar",
  AgriCoordinator: "Agri Coordinator",
  AssistantDirectorPP: "Assistant Director PP",
  BosscaInspectors: "BOSSCA Inspectors",
  BavasAgriCoordinator: "BAVAS Agri Coordinator",
  SaoUsers: "SAO Users",

  // DSS Feature Components - Schemes
  Schemes: "Schemes",
  SchemesDetails: "Schemes Details",
  SchemesDetailsPage: "Schemes Details Page",
  AllSchemes: "All Schemes",
  SchemesForm: "Schemes Form",
  SaveSchemeForm: "Save Scheme Form",
  DownloadSchemesDocument: "Download Schemes Document",
  SchemesListPage: "Schemes List Page",

  // DSS Feature Components - Schemes Applied
  AppliedSchemes: "Applied Schemes",
  AppliedSchemesPage: "Applied Schemes Page",

  // DSS Feature Components - Farmer Passbook
  FarmerPassbook: "Farmer Passbook",

  // DSS Feature Components - Assets/Storage
  "Cold Storages": "Cold Storages",
  "Agri Godowns": "Agri Godowns",
  PACS: "PACS",

  // DSS Feature Components - Assets/Offices
  "Panchayat Office": "Panchayat Office",
  "Panchayat Offices": "Panchayat Offices",
  "e-KISAN Bhawans": "e-KISAN Bhawans",
  "DAO offices": "DAO offices",

  // DSS Feature Components - Assets/Institutes
  KVKs: "KVKs",
  "Agriculture Colleges": "Agriculture Colleges",

  // DSS Feature Components - Assets/Bazar
  "Pashu Bazar": "Pashu Bazaar",
  "Market Nodes": "Market Nodes",
  FPOs: "FPOs",
  "Jaivik FPOs": "Jaivik FPOs",
  JaivikFPO: "Jaivik FPO",

  // DSS Feature Components - Assets/Industries
  foodProcessing: "Food Processing",
  EthanolIndustries: "Ethanol Industries",

  // DSS Feature Components - Assets/Other
  "Agri-Input Shops": "Agri-Input Shops",
  "Agriculture Farms": "Agriculture Farms",
  "Rice Mill": "Rice Mill",
  CHCs: "CHCs",
  Traders: "Traders",
  "Seed Dealers": "Seed Dealers",
  "सीड डीलर": "Seed Dealers",
  Banks: "Banks",
  "Govt Pond": "Govt Pond",
  "सरकारी तालाब": "Govt Pond",

  // DSS Feature Components - Advisory/Agri Tips
  PlantProtectionAdvisory: "Plant Protection Advisory",
  StaticAdvisory: "Static Advisory",

  // DSS Feature Components - Advisory/Weather
  WeatherBasedAdvisory: "Weather Based Advisory",

  // DSS Feature Components - Advisory/Soil Health
  SoilHealthLabData: "Soil Health Lab Data",
  SoilHealthDataAnalysis: "Soil Health Data Analysis",
  SoilHealthFileDownload: "Soil Health File Download",

  // DSS Feature Components - Advisory/Mandi
  PriceMandi: "Price Mandi",
  PriceMandiFilter: "Price Mandi Filter",
  PriceMandiDetails: "Price Mandi Details",

  // DSS Feature Components - Registration
  DbtBasedRegistration: "DBT Based Registration",
  NoDBTRegistration: "No DBT Registration",

  // DSS Feature Components - Profile
  ProfileCreationDBT: "Profile Creation DBT",
  LanguageChange: "Language Change",
  Profile: "Profile",

  // DSS Feature Components - Knowledge
  KnowledgeSection: "Knowledge Section",
  DSS_DRILL_INTO_VIEW: "Drill into {{interval}} view",

  Yes: "Yes",
  No: "No",

  GroupPresidentDBTRegistrationError: "The DBT registration number of the group president is mandatory.",
  DuplicateDBTRegistrationNumberError: "Duplicate dbt details",
  DSS_SELECT_PLACEHOLDER: "Select",
  BIHAR_KRISHI_APP: "Bihar Krishi",
  DIGITAL_FARMER_SERVICES: "Digital Farmer Services",
  GOVT_INITIATIVE_DESC: "A Government of Bihar initiative to digitise and streamline agricultural services for farmers across all 38 districts.",
  FACEBOOK_ICON: "Facebook",
  X_ICON: "X",
  X_FEED_CAROUSEL: "X feed",
  YOUTUBE_ICON: "YouTube",
  INSTAGRAM_ICON: "Instagram",
  WEBSITE_DEVELOPED_BY: "Website developed and managed by",
  ALL_RIGHTS_RESERVED: "All rights reserved.",
  TOTAL_VISITS: "Total Visits",
  MAUSAM_SEVA_KENDRA: "Mausam Seva Kendra",
  "India Meteorological Department": "India Meteorological Department",
  "भारत मौसम विज्ञान विभाग": "भारत मौसम विज्ञान विभाग",
  DETAILS: "Details",
  Details: "Details",
  Partner_Logos_Carousel: "Partner Logos Carousel",
  Partner_Logos_Section: "Partner Logos",
  Partner_Logos_Pagination: "Partner Logos Pagination",
  Visit_Website: "Visit",
  Go_To_Slide: "Go to slide",
  Bihar_Agri_Portal_Logo: "Bihar Agriculture Portal",
  NFSM_Logo: "National Food Security Mission, Government of India",
  Horticulture_Bihar_Logo: "Horticulture Bihar",
  Bihar_Beej_Logo: "Bihar Rajya Beej Nigam (BRBN)",
  Aadhaar_Logo: "Aadhaar – UIDAI, Government of India",
  Krishi_Vibhaag_Logo: "Krishi Vibhaag, Bihar Sarkar",
  Jal_Sansadhan_Logo: "Bihar Water Development Society (BWDS)",
  BAMETI_Logo: "BAMETI – Bihar Agricultural Management & Extension Training Institute",
  PM_Kisan_Logo: "PM KISAN, Government of India",

  // Generic pager (RewampPagination, Figma 836:14580) — aria labels only; the
  // visible "Showing N of M" summary comes from each page's own namespace.
  pagination: {
    ariaLabel: "Pagination",
    previous: "Previous page",
    next: "Next page",
    goToPage: "Go to page {{page}}",
    showing: "Showing",
    ofItems: "of {{count}} items",
    itemsPerPage: "Items per page",
  },
  // Global-search result-group heading for horti rows (heading = t(group.category)).
  "Marketplace Services": "Marketplace Services",
  IMD: "India Meteorological Department",
  fb4a: "Facebook",
  ig4a: "Instagram",
};
